import {isFunction} from 'lodash'

// * register Global Bus *
let CancelToken = axios.CancelToken
let cancel

window.bus = new Vue({
    name: 'GlobalBus',
    data: {
        tempValues: [],
        tempVariables: [],
        currentLiveFormulas: [],
        lastLiveFormulasResults: {}
    },
    created() {
        this.$on('calculation-changed', this.calculateView)
        this.$on('next-click', this.cancelRequest)
    },
    methods: {
        calculateView() {
            this.cancelRequest()

            axios.post('event-calculator/calculateView', {
                tempValues: this.tempValues,
                tempVariables: this.tempVariables,
                liveFormulas: this.currentLiveFormulas,
            }, {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c
                })
            }).then((response) => {
                this.lastLiveFormulasResults = response.data.liveFormulas
                this.$emit('viewCalculationDone', response.data.results, response.data.liveFormulas)
            }).catch((error) => {
                if(!axios.isCancel(error)) {
                    if (!error.response && !error.request) {
                        setTimeout(() => {
                            this.calculateView()
                        }, 3000)
                    }
                }
            })
        },
        cancelRequest() {
            // cancel the request
            if(isFunction(cancel)) {
                cancel()
            }
        }
    },
})